<template>
  <div>
    <div class="system">
      <div span="12" class="demo-tabs-style1">
        <i-tabs v-model="currentTab" @click.native="tabChange">
          <i-tabPane
            v-for="(item, index) in Object.keys(type)"
            :key="index"
            :label="item"
            :value="item"
            :name="item"
            class="tabs-label"
          >
            <div class="shuju" v-for="(_item, _index) in type[item]" :key="_index">
              <div class="function-part">
                <div class="function-title">{{ typeMap[_item] }}数据导入</div>
                <div class="function-content">
                  <form>
                    <div style="margin-left:60px ;">
                      <i-Radio-group vertical v-model="kind[_item]">
                        <i-radio label="replace">
                          <i-icon type="all"></i-icon>
                          <span style="font-size:18px;">全量</span>
                        </i-radio>
                        <i-radio label="extend">
                          <i-icon type="extend"></i-icon>
                          <span style="font-size:18px;">增量</span>
                        </i-radio>
                      </i-Radio-group>
                    </div>
                    <i-upload
                      action="//jsonplaceholder.typicode.com/posts/"
                      :before-upload="beforeUpload"
                      :ref="_item"
                      accept=".xlsx"
                      style="display: inline-block; padding: 0; margin-right: 40px;"
                      @click.native="getCurrentFileCategory(_item)"
                    >
                      <i-button icon="ios-cloud-upload-outline" style="width:150px;font-size: 15px;">
                        Upload files
                      </i-button>
                    </i-upload>
                    <i-button type="primary" style="width: 60px" @click="upload(_item)">确认</i-button>
                  </form>
                </div>
              </div>
              <div class="function-part">
                <div class="function-title">{{ typeMap[_item] }}数据导出</div>
                <div class="function-content">
                  <p
                    style="margin:15px;font-size: 18px; font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;"
                  >
                    下载全部数据，格式为xlsx
                  </p>
                  <p style="margin-left: 256px;">
                    <i-button class="download-btn" type="primary">
                      <a class="download-a" :href="$store.state.baseurl + 'api/system/indicator?category=' + _item">
                        下载
                      </a>
                    </i-button>
                  </p>
                </div>
              </div>
            </div>
          </i-tabPane>
        </i-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { KeFuMixin } from "../common/mixin"

export default {
  name: "IndexMark",
  mixins: [KeFuMixin],
  data() {
    return {
      frontTab: "中国版",
      currentTab: "中国版",
      kind: {
        province: "replace",
        city: "replace",
        world: "replace",
      },
      type: {
        中国版: ["province", "city"],
        世界版: ["world"],
      },
      typeMap: {
        province: "省级",
        city: "市级",
        world: "世界",
      },
      fileData: {
        province: null,
        city: null,
        world: null,
      },
      currentFile: "province",
    }
  },
  methods: {
    // 点击监听当前是哪个category
    getCurrentFileCategory(category) {
      this.fileData = {
        province: null,
        city: null,
        world: null,
      }
      this.$refs.province[0].clearFiles()
      this.$refs.city[0].clearFiles()
      this.$refs.world[0].clearFiles()
      this.currentFile = category
    },
    // 绑定before-upload，返回false，阻止默认上传流程，手动控制文件上传。
    beforeUpload(file) {
      this.fileData[this.currentFile] = file
      return true
    },
    // 上传
    async upload(category) {
      const fileData = this.fileData[category]
      if (!fileData) {
        this.$Message.error("请先上传文件")
        return
      }
      const kind = this.kind[category]
      let bodyFormData = new FormData()
      bodyFormData.append("category", category)
      bodyFormData.append("file", fileData)
      bodyFormData.append("kind", kind)
      let self = this
      try {
        const res = await self.axios({
          method: "post",
          url: self.$store.state.baseurl + "api/system/indicator",
          headers: { "Content-Type": "multipart/form-data" },
          data: bodyFormData,
        })
        if (!res) {
          return
        }
        if (res.data.code === 0) {
          this.$Message.success("上传成功")
        } else {
          self.showLoading = false
          self.$Message.error("操作失败，错误原因：" + res.data.error_message)
        }
      } catch (err) {
        self.showLoading = false
        self.$Message.error("操作失败，错误原因：" + err)
      }
    },
    // 下载
    async download(category) {
      let self = this
      try {
        const res = await self.axios({
          method: "get",
          url: self.$store.state.baseurl + "api/system/indicator",
          params: {
            category,
          },
        })
        if (!res) {
          return
        }
        // 下载文件
        const link = document.createElement("a")
        let blob = new Blob([res.data], { type: "application/vnd.ms-excel" })
        link.style.display = "none"
        link.href = URL.createObjectURL(blob)
        link.download = category + ".xlsx"
        document.body.appendChild(link)
        link.click()
      } catch (err) {
        if (err.toString().indexOf("500") !== -1) {
          self.showLoading = false
          self.$Message.error("请重新登录！")
          this.setCookie("login", "false")
          this.$router.push("/login")
        } else {
          self.showLoading = false
          self.$Message.error("操作失败，错误原因：" + err)
        }
      }
    },
    // tab切换
    tabChange() {
      if (this.frontTab !== this.currentTab) {
        this.fileData = {
          province: null,
          city: null,
          world: null,
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.system {
  width: 100%;
  margin-left: 30px;
  margin-top: 15px;
}
// tab模块
.demo-tabs-style1 > .ivu-tabs-card > .ivu-tabs-content {
  height: 120px;
  margin-top: 0;
}
.demo-tabs-style1 > .ivu-tabs-card > .ivu-tabs-content > .ivu-tabs-tabpane {
  // background: #fff;
  padding: 16px;
}
.demo-tabs-style1 > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
  height: 90px !important;
  border-color: transparent;
}
.demo-tabs-style1 > .ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active {
  height: 90px !important;
  border-color: #fff;
}
// 数据导入模块
.shuju {
  overflow: hidden;
  width: 100%;
  padding: 10px;
}
.function-part {
  padding: 10px;
  margin-top: 2rem;
  font-size: 1rem;
}
.function-title {
  padding: 0;
  text-align: left;
  font-size: 20px;
  font-weight: 600;
}
.function-content {
  width: 400px;
  margin-left: 5rem;
}
.function-content form div {
  width: 120px;
  // background-color: azure;
  margin-bottom: 15px;
}
.button-a {
  color: inherit;
  text-decoration: none;
}
.download-btn {
  width: 70px;
  padding: 0 !important;
}
.download-a {
  display: inline-block;
  width: 70px;
  color: white;
  height: 32px;
  line-height: 32px;
}
</style>

<style>
.demo-tabs-style1 .ivu-tabs-tab {
  font-size: 22px !important;
  /* width: 90px; */
  height: 50px !important;
  line-height: 40px !important;
}
.demo-tabs-style1 .ivu-tabs-nav-container {
  height: 50px !important;
}
.tabs-label {
  font-size: 18px;
}
</style>
